/**
 * @type {{[field:string] : import("modules/global/typing/enums/dealers.enum").DealerStatusEnum}}
 */
export const DEALER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};
